/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { authActions, selectAuth } from "Features/auth";
import { SnAuth } from "Widgets/sn_auth";
import { CancellationPolicyText, PrivacyPolicyText, TermsAndConditionsText, UserAgreementsText } from "Shared/bigTexts";
import { EyeIcon } from "Shared/icons";
import { Button, Checkbox, Input, Modal } from "Shared/ui";

import SelectLanguage from "Widgets/lang_select";
import "../auth.scss";
import { errorActions, selectError } from "Features/error";
import { useEffect } from "react";

const initialVisibleAgreement = {
	privacyPolicy: false,
	termsAndConditions: false,
	userAgreements: false,
	cancellation: false,
};

export const RegisterPage = () => {
	const dispatch = useDispatch();
	const authFetch = useSelector(selectAuth.fetch);
	const [userData, setUserData] = useState({ login: "", password: "", email: "" });
	const [errors, setErrors] = useState(null);
	const [isCheckedAgreements, setIsCheckedAgreements] = useState(false);
	// const isErrors = Object.values(errors).some((val) => !!val);
	const [isVisibleAgreement, setIsVisibleAgreement] = useState(initialVisibleAgreement);
	const errorPage = useSelector(selectError.page);
	const errorMessages = useSelector(selectError.message);

	useEffect(() => {
		return () => {
			dispatch(errorActions.drop());
		};
	}, []);

	useEffect(() => {
		if (errorPage === "register") {
			errorHandler();
		}
	}, [errorPage]);

	function errorHandler() {
		const login = errorMessages.filter((er) => er?.toLowerCase().includes("login"));
		const email = errorMessages.filter((er) => er?.toLowerCase().includes("email"));
		const password = errorMessages.filter((er) => er?.includes("password"));
		const renderErrors = {};
		if (login.length) renderErrors.login = login;
		if (email.length) renderErrors.email = email;
		if (password.length) renderErrors.password = password;

		setErrors(renderErrors);
	}

	function onChangeUserData(key, value) {
		setUserData({ ...userData, [key]: value });
		if (errors?.[key]) {
			dispatch(errorActions.drop());
			setErrors({ ...errors, [key]: [] });
		}
	}

	const onChangeLogin = (key) => onChangeUserData("login", key);
	const onChangePassword = (key) => onChangeUserData("password", key);
	const onChangeMail = (key) => onChangeUserData("email", key);

	function onSubmit() {
		dispatch(authActions.register(userData));
	}

	const showAgreement = (key) => setIsVisibleAgreement({ ...isVisibleAgreement, [key]: true });

	const showPrivacyPolicy = () => showAgreement("privacyPolicy");
	const showTermsAndConditions = () => showAgreement("termsAndConditions");
	const showTermsUserAgreements = () => showAgreement("userAgreements");
	const showCancellation = () => showAgreement("cancellation");

	function toggleChecked() {
		setIsCheckedAgreements(!isCheckedAgreements);
	}

	function hideModals() {
		setIsVisibleAgreement(initialVisibleAgreement);
	}

	const agreementSButton = [<Button key={"okAgreement"} text={"OK"} onClick={hideModals} type={"orange"} />];

	return (
		<div className="auth">
			<div className="auth__container auth__container_w500">
				<div className="auth__block">{/* <SelectLanguage /> */}</div>
				<div className="auth__line mb-30" />
				<div className="auth__block mb-30">
					<div className="auth__block-text mb-10">
						<span className="auth__block-text_big">Registration</span>
					</div>
					<div className="auth__block-container">
						<div className="auth__block-text auth__block-text_small ">Already have an account?</div>
						<Link to={"/auth/login"}>Sign in</Link>
					</div>
				</div>
				<div className="auth__block-container mb-30">
					<SnAuth />
				</div>
				<div className="auth__block-container mb-20">
					<div className="auth__line" />
					<div className="auth__block-text auth__block-text_middle mr-10 ml-10">Or</div>
					<div className="auth__line" />
				</div>
				<div className="auth__block-text auth__block-text_middle mb-20">Register with email</div>
				<Input
					placeholder="Login*"
					type={"text"}
					className="mb-17"
					outValue={userData.login}
					setOutValue={onChangeLogin}
					errorMessage={errors?.login}
				/>
				<Input
					placeholder="Email*"
					type={"email"}
					className="mb-17"
					outValue={userData.email}
					setOutValue={onChangeMail}
					errorMessage={errors?.email}
				/>

				<Input
					placeholder="Password*"
					type={"password"}
					className="mb-17"
					outValue={userData.password}
					setOutValue={onChangePassword}
					errorMessage={errors?.password}
					Icon={EyeIcon}
				/>

				<div className="auth__block-container" style={{ alignItems: "flex-start" }}>
					<div className="mr-10">
						<Checkbox checked={isCheckedAgreements} onChange={toggleChecked} />
					</div>
					<div className="auth__agreement mb-30">
						<div className="auth__block-text auth__block-text_small">I agree with the</div>
						<Link onClick={showPrivacyPolicy}>Privacy policy,</Link>
						<Link onClick={showTermsUserAgreements}>User agreement,</Link>
						<Link onClick={showTermsAndConditions}>Terms and conditions,</Link>
						<Link onClick={showCancellation}>Cancellation policy</Link>
					</div>
				</div>

				<Button
					text="Continue"
					onClick={onSubmit}
					className={"mb-5"}
					disabled={!isCheckedAgreements || errorMessages.length}
					isLoading={authFetch}
				/>
			</div>

			<Modal isVisible={isVisibleAgreement.privacyPolicy} buttons={agreementSButton}>
				<PrivacyPolicyText />
			</Modal>
			<Modal isVisible={isVisibleAgreement.termsAndConditions} buttons={agreementSButton}>
				<TermsAndConditionsText />
			</Modal>
			<Modal isVisible={isVisibleAgreement.userAgreements} buttons={agreementSButton}>
				<UserAgreementsText />
			</Modal>
			<Modal isVisible={isVisibleAgreement.cancellation} buttons={agreementSButton}>
				<CancellationPolicyText />
			</Modal>
		</div>
	);
};
